import dayjs from "dayjs"
import isoWeek from "dayjs/plugin/isoWeek"
import utc from "dayjs/plugin/utc"

import type { ProjectDocument } from "../../Project/types/project-documents.types.ts"
import type { FilesFilters } from "../types/files-filters.types.ts"

dayjs.extend(isoWeek)
dayjs.extend(utc)

const ATTACHMENT_FILE_TYPE_PHOTOS = "photos"

const startOfRange = (range: string, now: dayjs.Dayjs) => {
  if (range === "today") return now.startOf("day")
  if (range === "this_week") return now.startOf("isoWeek")
  if (range === "this_month") return now.startOf("month")
  return null
}

// The document endpoint answers none of the drawer filters, so they are
// applied here with the same meaning the attachment endpoint gives them:
// a document is never a photo and never hangs off a related record, and
// the date ranges are cut in UTC because that is the server's clock.
export const documentMatchesFilters = (
  document: ProjectDocument,
  filters: FilesFilters,
  now = dayjs.utc()
): boolean => {
  if (filters.model_type) return false
  if (filters.file_type === ATTACHMENT_FILE_TYPE_PHOTOS) return false
  // A document can never belong to an album — that relationship only exists
  // on the Attachment side of the model.
  if (filters.album) return false
  if (filters.folder && document.folder !== filters.folder) return false
  if (filters.owner && document.uploaded_by !== filters.owner) return false
  if (filters.date_range) {
    const start = startOfRange(filters.date_range, now)
    if (start && dayjs.utc(document.created).isBefore(start)) return false
  }
  return true
}
